// extracted by mini-css-extract-plugin
export default {"status_button_selected":"StatusButtonComponent_status_button_selected__IpA3o","status_button":"StatusButtonComponent_status_button__1FzPZ"};